import { Stats } from "./types.d";

export const initStats: Stats = {
    correct: 0,
    total: 0,
    reviewing: 6,
}